import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { normalizeTransactionGlLines, TransactionGlLine } from '../../models/transaction-gl.model';

export interface TransactionGlModalData {
	title: string;
	lines: TransactionGlLine[] | null | undefined;
}

@Component({
	selector: 'app-transaction-gl-modal',
	templateUrl: './transaction-gl-modal.component.html',
	styleUrls: ['./transaction-gl-modal.component.scss'],
})
export class TransactionGlModalComponent implements OnInit {
	debitTotal = 0;
	creditTotal = 0;
	hasLines = false;

	constructor(
		public dialogRef: MatDialogRef<TransactionGlModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: TransactionGlModalData
	) {}

	ngOnInit(): void {
		const n = normalizeTransactionGlLines(this.data?.lines);
		this.hasLines = n.length > 0;
		this.debitTotal = n.reduce((s, r) => s + r.debit, 0);
		this.creditTotal = n.reduce((s, r) => s + r.credit, 0);
	}

	close(): void {
		this.dialogRef.close();
	}
}
